import * as React from 'react';
import classnames from 'classnames';
import styles from './fieldset.css';
export const Fieldset = ({ description, classes, children, }) => (React.createElement("fieldset", { className: classnames(styles.Fieldset, classes) },
    React.createElement("legend", null,
        React.createElement("span", { className: styles.InvisibleLegend }, description)),
    children));
